export default __webpack_public_path__ + "static/media/icon-close-white.e68b1589.svg";